import { Card, Col, Row, Spin, Statistic } from 'antd';
import numeral from 'numeral';
import React from 'react';
import { i18n } from '../../../../translations';
import { GroupAnalyticsNewTKeys } from '../../../../translations/keys';
var ProjectStatisticsCard = function (_a) {
    var loading = _a.loading, analyticsData = _a.analyticsData, equipments = _a.equipments;
    var FUEL_ENABLED = (analyticsData && analyticsData.fuel_available_equipments.length) || 0;
    return (React.createElement(Col, { span: 24 },
        React.createElement(Spin, { spinning: loading },
            React.createElement(Card, { headStyle: { fontSize: '16px' }, title: React.createElement(React.Fragment, null,
                    i18n.t(GroupAnalyticsNewTKeys.projectStatistics),
                    " ") },
                React.createElement(Row, null,
                    React.createElement(Col, { span: 6 }, FUEL_ENABLED > 0 &&
                        analyticsData &&
                        analyticsData.total_fuel_consumption > 0 ? (React.createElement(Statistic, { title: i18n.t(GroupAnalyticsNewTKeys.fuelConsumed), value: numeral(analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.total_fuel_consumption).format('0,0') })) : (React.createElement(Statistic, { title: i18n.t(GroupAnalyticsNewTKeys.fuelConsumed), valueStyle: {
                            fontSize: 14,
                            background: '#f0f0f0',
                            borderRadius: 4,
                            padding: 8,
                            marginRight: 20,
                        }, value: i18n.t(GroupAnalyticsNewTKeys.fuelNotInstalled) + '' }))),
                    React.createElement(Col, { span: 6 },
                        React.createElement(Statistic, { title: 'Tracked equipment', value: Object.values(equipments).filter(function (a) { return a.ignition_status !== undefined; }).length })),
                    React.createElement(Col, { span: 6 },
                        React.createElement(Statistic, { title: i18n.t(GroupAnalyticsNewTKeys.avgRunHours), value: analyticsData === null || analyticsData === void 0 ? void 0 : analyticsData.average_run_hours.toFixed(2), suffix: i18n.t(GroupAnalyticsNewTKeys.hours) })),
                    React.createElement(Col, { span: 6 },
                        React.createElement(Statistic, { title: i18n.t(GroupAnalyticsNewTKeys.avgUtilisationEngineOn), value: analyticsData
                                ? (analyticsData.average_utilization *
                                    100).toFixed(1)
                                : 100, suffix: '%' })))))));
};
export default ProjectStatisticsCard;
